import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLogged, logout } = useContext(AuthContext);

  useEffect(() => {
    // no-op: effect kept to update UI when location changes if needed
  }, [location]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className="bg-gray-900/60 backdrop-blur-sm text-white py-4 fixed w-full z-40 px-6">
      <div className="container mx-auto flex items-center justify-between">
        {/* Website Name */}
        <div className="flex items-center flex-shrink-0 mr-6">
          <Link to="/" className="text-2xl font-bold tracking-wide">
            Matka House
          </Link>
        </div>

        {/* Navbar Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <Link to={`/search/random/all`} className="hover:underline">
            Recipes
          </Link>
          <Link to="/about" className="hover:underline">
            About
          </Link>
        </div>

        {/* Auth Links */}
        <div className="hidden md:flex items-center space-x-4">
          {!isLogged ? (
            <>
              <Link to="/login" className="hover:underline">
                Login
              </Link>
              <Link to="/register" className="px-3 py-1 bg-white text-gray-900 rounded-md font-medium">
                Register
              </Link>
            </>
          ) : (
            <button onClick={handleLogout} className="px-3 py-1 bg-red-600 rounded-md text-white">
              Logout
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
